export default "/static/webpack/images/how-it-works/discovery.png";